import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {Button, Checkbox, TextField} from '@goguardian/based';
import ProgressSteps from '../progress';
import {setSurveyInterests} from '_shared/actions';
import Select from 'react-select';

import style from './style.scss';
import 'react-select/dist/react-select.css';

class SurveyQuestions extends React.Component {

  constructor(...args) {
    super(...args);

    const interests = this.props.interests ?
      this.props.interests.split(';').map((value) => {
        return {value: value, label: value};
      }) : [];
    this.state = {
      interests: interests
    };

    this.setInterests = this.setInterests.bind(this);
    this.setOther = this.setOther.bind(this);
    this.back = this.back.bind(this);
    this.next = this.next.bind(this);
  }

  setInterests(interests) {
    this.setState({
      interests: interests
    });

    // Update state selections in case user presses `back`
    const selections = interests.map(item => item.value).join(';');
    this.props.dispatch(setSurveyInterests(selections));
  }

  setOther(other) {
    this.setState({
      other: other
    });
  }

  back() {
    this.props.router.push({
      pathname: '/survey/start'
    });
  }

  next() {
    const { interests } = this.state;

    const selections = interests.map(item => item.value).join(';');

    this.props.dispatch(setSurveyInterests(selections));
    this.props.router.push({
      pathname: '/survey/end'
    });
  }

  render() {
    const { interests } = this.state;
    const options = [
      {value: 'Classroom Management', label: 'Classroom Management'},
      {value: 'Teacher Chat', label: 'Teacher Chat'},
      {value: 'Device Analytics', label: 'Device Analytics'},
      {value: 'Web Filtering', label: 'Web Filtering'},
      {value: 'Theft Recovery', label: 'Theft Recovery'},
      {value: 'Flagged Activity', label: 'Flagged Activity'},
      {value: 'Support Blended Learning Goals', label: 'Support Blended Learning Goals'},
      {value: 'Device Management', label: 'Device Management'},
      {value: 'Personalized Learning', label: 'Personalized Learning'}
    ];

    return (
      <div>
        <ProgressSteps
          steps={['Sign Up', 'Quick Questions', 'Get Started']}
          current={2} />
        <div className={style.surveyContainer}>
          <div className={style.icon}></div>
          <h2>Why are you using GoGuardian?</h2>
          <h3>SELECT ALL THAT APPLY</h3>
          <Select
            className={style.dropdown}
            value={interests}
            multi={true}
            options={options}
            onChange={this.setInterests}
            />
          <div className={style.buttons}>
            <Button onClick={this.back} type="secondary">Back</Button>
            <Button onClick={this.next}>Next</Button>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    interests: state.surveyInterests
  };
};

export default connect(mapStateToProps)(withRouter(SurveyQuestions));



/** WEBPACK FOOTER **
 ** ./src/app/components/survey/questions/index.jsx
 **/